import { render, staticRenderFns } from "./Troskovnik.vue?vue&type=template&id=436f545c&"
import script from "./Troskovnik.vue?vue&type=script&lang=js&"
export * from "./Troskovnik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports